import {Routes} from "@angular/router";
import {ProjectViewComponent} from "../../projects/project-view/project-view.component";
import {ProjectViewRoutes} from "../../projects/project-view/project-view.routes";
import {ProjectCreateComponent} from "../../projects/project-create/project-create.component";
import {ProductViewComponent} from "../../products/product-view/product-view.component";
import {ProductViewRoutes} from "../../products/product-view/product-view.routes";
import {StoreCollectionViewComponent} from "../../store-collection/store-collection-view/store-collection-view.component";
import {StoreCollectionViewRoutes} from "../../store-collection/store-collection-view/store-collection-view.routes";
import {UserViewComponent} from "../../users/user-view/user-view.component";
import {routerHandler} from "../../../resources/utils/router";
import {ProductCreateComponent} from "../../products/product-create/product-create.component";
import {StoreCollectionCreateComponent} from "../../store-collection/store-collection-create/store-collection-create.component";
import {StoreVersionCreateComponent} from "../../store-version/store-version-create/store-version-create.component";
import {StoreVersionEditComponent} from "../../store-version/store-version-edit/store-version-edit.component";
import {ActionCreateComponent} from "../../action/action-create/action-create.component";
import {ActionEditComponent} from "../../action/action-edit/action-edit.component";
import {AccountViewComponent} from "../../account/account-view/account-view.component";
import {AccountViewRoutes} from "../../account/account-view/account-view.routes";
import {UserViewRoutes} from "../../users/user-view/user-view.routes";
import {StoreViewRoutesData} from "./store-view.routes";
import {CustomDataCreateComponent} from '../../custom-data/custom-data-create/custom-data-create.component';
import {CustomDataEditComponent} from '../../custom-data/custom-data-edit/custom-data-edit.component';
import {CustomDataRoutes} from '../../custom-data/custom-data-routes/custom-data-routes.module';


export const StoreViewChildrenRoutesData = routerHandler.injectionChildren(StoreViewRoutesData, {
  'info': [
    routerHandler.view('project', {
      component: ProjectViewComponent, children: ProjectViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
  ],
  'projects': [
    routerHandler.create('project', {
      component: ProjectCreateComponent, outer: true
    }),
    routerHandler.view('project', {
      component: ProjectViewComponent, children: ProjectViewRoutes, outer: true
    }),
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('store-collection', {
      component: StoreCollectionViewComponent, children: StoreCollectionViewRoutes, outer: true, prefix: true
    }),
  ],
  'purchases': [
    routerHandler.view('user', {
      component: UserViewComponent, children: UserViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
  ],
  'products': [
    routerHandler.create('product', {
      component: ProductCreateComponent, outer: true
    }),
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true
    }),
  ],
  'storeCollections': [
    routerHandler.create('store-collection', {
      component: StoreCollectionCreateComponent, outer: true
    }),
    routerHandler.view('store-collection', {
      component: StoreCollectionViewComponent, children: StoreCollectionViewRoutes, outer: true
    }),
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
    routerHandler.view('project', {
      component: ProjectViewComponent, children: ProjectViewRoutes, outer: true, prefix: true
    }),
  ],
  'versions': [
    routerHandler.create('store-version', {
      component: StoreVersionCreateComponent, outer: true
    }),
    routerHandler.edit('store-version', {
      component: StoreVersionEditComponent, outer: true
    }),
  ],

  'custom-data': [
    routerHandler.create('custom-data', {
      component: CustomDataCreateComponent, outer: true
    }),
    routerHandler.edit('custom-data', {
      component: CustomDataEditComponent, outer: true
    }),
  ],
  'actions': [
    routerHandler.create('action', {
      component: ActionCreateComponent, outer: true
    }),
    routerHandler.edit('action', {
      component: ActionEditComponent, outer: true
    }),
    // TODO product?
    routerHandler.view('product', {
      component: ProductViewComponent, children: ProductViewRoutes, outer: true, prefix: true
    }),
  ],
  'users': [
    routerHandler.view('user', {
      component: UserViewComponent, children: UserViewRoutes, outer: true
    }),
    routerHandler.view('account', {
      component: AccountViewComponent, children: AccountViewRoutes, outer: true, prefix: true
    }),
  ]
});

export const StoreViewChildrenRoutes: Routes = Object.values(StoreViewChildrenRoutesData);
